import React, {createRef} from 'react'
import BaseComponent, {
	AjaxParam,
} from '../../common/BaseComponent/BaseComponent'
import PopupNew from '../../common/primitives/PopupNew'

import styles from './ComponentOrderRequiredFields.scss'
import {ContextDataStore} from '../../common/helpers/HelperGlobalDataStore'
import LoadingRow from '../../common/primitives/LoadingRow'
import RenderIf from '../../common/primitives/RenderIf/RenderIf'
import TextBox, {textBoxStyles} from '../../common/primitives/TextBox'
import textAreaStyles from '../../common/primitives/TextArea.scss'
import TextArea from '../../common/primitives/TextArea'
import Submit from '../../common/primitives/Submit'
import {__t} from '../../common/lang/text-resource'

class ComponentOrderRequiredFileds extends BaseComponent {
	loading = true
	popupVisible = true
	errors = {
		city: '',
		address: '',
		postCode: '',
	}

	popupRef = createRef()

	componentDidMount() {
		super.componentDidMount()

		this.loading = true
		this.forceUpdate()

		const ap = new AjaxParam()
		ap.callbackSuccess = (data) => {
			this.loading = false
			this.setState({...data})
		}

		this.ajaxCall('ActionGetDefaultState', {}, ap)
	}

	onChange = (event) => {
		const state = this.state
		state.componentData.contactData[event.target.name] = event.target.value
		this.setState({...state})
	}

	onSubmit = (e) => {
		e.preventDefault()

		const {contactData} = this.state.componentData
		let hasError = false
		this.errors = {
			city: '',
			address: '',
			postCode: '',
		}

		if (contactData.city === '') {
			this.errors.city = __t('Полето е задължително!')
			hasError = true
		}

		if (contactData.address === '') {
			this.errors.address = __t('Полето е задължително!')
			hasError = true
		}

		if (contactData.postCode === '') {
			this.errors.postCode = __t('Полето е задължително!')
			hasError = true
		}

		if (hasError) {
			this.forceUpdate()
			return
		}

		this.loading = true
		this.forceUpdate()

		const ap = new AjaxParam()

		ap.callbackSuccess = () => {
			this.eventRaise('ContactDataChanged')
			document.body.style.overflow = 'auto'
			this.props.onClose();
		}
		ap.callbackError = () => {
			window.location.reload()
		}

		this.ajaxCall('ActionSetRequiredFields', {contactData}, ap)
	}

	render() {
		const {forceAddress, forceCity, contactData} = this.state.componentData
		return (
		  <PopupNew
			name={'required_fields_popup'}
			isVisible={this.popupVisible}
			ref={this.popupRef}
			closeCallBack={this.props.onClose}
		  >
			  <div className={styles.container}>
				  <RenderIf condition={this.loading === true}>
					  <LoadingRow/>
				  </RenderIf>
				  <RenderIf condition={this.loading !== true}>
					  <form onSubmit={this.onSubmit}>
						  <div data-layout='margin-top--smm padding-top--xxs'>
							  <div data-layout='row start gutter-none'>
								  <div data-layout='col 12' className={styles.innerContainer}>
									  <div data-layout='row gutter-none middle'>
										  <div
											data-layout='col 12 4@md'
											className={styles.labelContainer}
										  ></div>
										  <div data-layout='col	12 8@md margin-bottom--xs padding-bottom--xxs'>
											  <h1>{__t('Въвеждане на допълнителна информация')}</h1>
											  <div>
												  {__t('в-поръчката-е-добавен-домейн-който-изисква-въвеждda904f')}
											  </div>
										  </div>
									  </div>
									  <div data-layout='row gutter-none start margin-top--xs'>
										  <div data-layout='col 12 8@md offset-4@md'>
											  <p>{__t('* Задължителни полета')}</p>
										  </div>
									  </div>
									  <RenderIf condition={forceCity === true}>
										  <div
											data-layout='row gutter-none middle'
											className={`${styles.multiColContainer} ${styles.cityContainer}`}
										  >
											  <div
												data-layout='col 8 4@md first@md'
												className={styles.labelContainer}
											  >
												  <label htmlFor='whois_city'>
													  <span>*</span>
													  {__t('град')}
												  </label>
											  </div>

											  <div
												data-layout='col 4 1@md '
												className={styles.labelContainer}
											  >
												  <label htmlFor='whois_postcode'>
													  <span>*</span>
													  {__t('пк')}
												  </label>
											  </div>
											  <div
												data-layout='col 8 5@md first@md  margin-bottom--xs padding-bottom--xxs'>
												  <TextBox
													className={textBoxStyles.transparent}
													error={this.errors.city}
													name={'city'}
													id={'whois_city'}
													value={contactData.city}
													placeholder={__t('София')}
													onChange={this.onChange}
												  />
											  </div>
											  <div data-layout='col 4 2@md margin-bottom--xs padding-bottom--xxs'>
												  <TextBox
													className={textBoxStyles.transparent}
													name={'postCode'}
													error={this.errors.postCode}
													id={'whois_postcode'}
													value={contactData.postCode}
													placeholder={'1000'}
													onChange={this.onChange}
												  />
											  </div>
										  </div>
									  </RenderIf>
									  <RenderIf condition={forceAddress === true}>
										  <div data-layout='row gutter-none middle'>
											  <div
												data-layout='col 12 4@md'
												className={styles.labelContainer}
											  >
												  <label htmlFor='whois_address'>
													  <span>*</span>
													  {__t('адрес')}
												  </label>
											  </div>
											  <div data-layout='col 12 8@md'>
												  <TextArea
													name={'address'}
													error={this.errors.address}
													placeholder={__t('бул. "Д-р Г.М. Димитров" 36')}
													id={'whois_address'}
													value={contactData.address}
													className={textAreaStyles.transparent}
													onChange={this.onChange}
												  />
											  </div>
										  </div>
									  </RenderIf>
									  <div data-layout='row gutter-none middle'>
										  <div
											data-layout='col 12 4@md'
											className={styles.labelContainer}
										  ></div>
										  <div data-layout='col 12 8@md margin-top--md text-center'>
											  <Submit value={__t('Запази и продължи')}/>
										  </div>
									  </div>
								  </div>
							  </div>
						  </div>
					  </form>
				  </RenderIf>
			  </div>
		  </PopupNew>
		)
	}
}

// React Context binding
ComponentOrderRequiredFileds.contextType = ContextDataStore

export default ComponentOrderRequiredFileds